import { guessInvitationToken } from '~/utils';

export default {
  validate(value: string) {
    return !!guessInvitationToken(value);
  },
};
